import {
  buildProgramEmailHtml,
  buildProgramEmailPlainText,
} from '@/domains/pages/ai-proficiency/utils/build-program-email-html';
import type { UpskillingProgramTemplate } from '@/domains/pages/ai-proficiency/fixtures/upskilling-program-templates';

export async function copyProgramEmailToClipboard(template: UpskillingProgramTemplate): Promise<void> {
  const html = buildProgramEmailHtml(template);
  const plainText = buildProgramEmailPlainText(template);

  if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([plainText], { type: 'text/plain' }),
      }),
    ]);
    return;
  }

  await navigator.clipboard.writeText(plainText);
}
